(function () {
  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var dock = document.querySelector(".mobile-dock");
    if (!dock) return;

    // Shopify injects a staff-only "preview bar" iframe fixed to the bottom
    // of the screen for logged-in staff viewing the live storefront. It can
    // overlap and intercept taps on the dock. When present, push the dock up
    // above it so it stays tappable. Real customers never have this iframe,
    // so this is a no-op for them.
    function syncPreviewBarOffset() {
      var bar = document.getElementById("PBarNextFrameWrapper") || document.getElementById("PBarNextFrame");
      var h = bar ? bar.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty("--dock-preview-offset", h > 0 ? h + "px" : "0px");
    }
    syncPreviewBarOffset();
    window.addEventListener("resize", syncPreviewBarOffset);
    new MutationObserver(syncPreviewBarOffset).observe(document.body, { childList: true });

    // Cart: the live header runs its own cart drawer (window.BTCart), not
    // the theme's native cart-drawer component. Reuse that directly.
    var cartBtn = dock.querySelector('[data-dock-action="cart"]');
    if (cartBtn) {
      cartBtn.addEventListener("click", function () {
        if (window.BTCart && typeof window.BTCart.open === "function") {
          window.BTCart.open();
          return;
        }
        var headerCartBtn = document.getElementById("bt-cart-btn");
        if (headerCartBtn) {
          headerCartBtn.click();
          return;
        }
        window.location.href = "/cart";
      });
    }

    // Menu and Account both use the same slide-up sheet mechanics, one
    // panel at a time. The live header's nav has no mobile collapse of its
    // own, so the menu panel also serves as the real mobile navigation.
    var lastFocused = null;
    var panels = [];

    function registerSheet(triggerSelector, panelId) {
      var btn = dock.querySelector(triggerSelector);
      var panel = document.getElementById(panelId);
      if (!btn || !panel) return null;
      var entry = { btn: btn, panel: panel };

      function open() {
        panels.forEach(function (p) {
          if (p !== entry && p.panel.classList.contains("is-open")) p.close();
        });
        lastFocused = document.activeElement;
        panel.hidden = false;
        document.documentElement.classList.add("mobile-dock-menu-lock");
        btn.setAttribute("aria-expanded", "true");
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            panel.classList.add("is-open");
          });
        });
      }

      function close() {
        panel.classList.remove("is-open");
        btn.setAttribute("aria-expanded", "false");
        document.documentElement.classList.remove("mobile-dock-menu-lock");
        setTimeout(function () {
          panel.hidden = true;
        }, 220);
        if (lastFocused && lastFocused.focus) lastFocused.focus();
      }

      entry.open = open;
      entry.close = close;

      btn.addEventListener("click", function () {
        if (panel.classList.contains("is-open")) {
          close();
        } else {
          open();
        }
      });
      panel.querySelectorAll("[data-dock-menu-close]").forEach(function (el) {
        el.addEventListener("click", close);
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && !panel.hidden) close();
      });

      panels.push(entry);
      return entry;
    }

    registerSheet('[data-dock-action="menu"]', "mobile-dock-menu-panel");
    registerSheet('[data-dock-action="account"]', "mobile-dock-account-panel");

    // Highlight the current section based on the page path.
    var path = window.location.pathname.replace(/\/$/, "") || "/";
    dock.querySelectorAll(".mobile-dock__item[data-dock-match]").forEach(function (item) {
      var match = item.getAttribute("data-dock-match");
      if (match === "/" ? path === "/" : path.indexOf(match) === 0) {
        item.classList.add("is-active");
        item.setAttribute("aria-current", "page");
      }
    });
  });
})();
